
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

var oneTime = true;

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target.id != 'searchInput') {
        this.onSubmitHandler(event);
      }
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const url = `${window.location.pathname}?filter.v.availability=1`;

    if (oneTime && !window.location.search){
      FacetFiltersForm.renderSectionFromFetch(url,null);
      oneTime = false;
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', function (event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      const openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;

      const summaryElement = openDetailsElement.querySelector('summary');
      openDetailsElement.removeAttribute('open');
      summaryElement.focus();
    });

    const filterTitle = this.querySelector('#FacetsWrapperDesktop .filter__title');
    if (filterTitle) filterTitle.addEventListener('click', function (event) {
      const collection_filter = event.target.closest('.collection-filter');
      if (!collection_filter) return;

      collection_filter.classList.toggle('open');

      if (window.innerWidth < 1024) {
        document.querySelector('#header-announcement-container').classList.toggle('filters-open');
        document.querySelector('#shopify-section-header').classList.toggle('filters-open');

        if (collection_filter.classList.contains('open')) {
          document.querySelector('html').style.overflow = 'hidden';
        }
      }
    });

    const filterCloseMobile = document.querySelector('.filters__header-mobile__close');
    if (filterCloseMobile) filterCloseMobile.addEventListener('click', function (event) {

      const collection_filter = event.target.closest('.collection-filter');
      if (!collection_filter) return;

      collection_filter.classList.remove('open');

      if (window.innerWidth < 1024) {
        document.querySelector('html').style.overflow = '';

        setTimeout(function () {
          document.querySelector('#header-announcement-container').classList.remove('filters-open');
          document.querySelector('#shopify-section-header').classList.remove('filters-open');
        }, 1000)
      }
    });

    const sortByMobile = this.querySelector('#sort_by');
    if (sortByMobile) sortByMobile.addEventListener('change', function (event) {
      document.querySelector('input[value=' + this.value + ']').checked = true;
      event.stopPropagation();
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    document.getElementById('ProductGridContainer').classList.add('loading');
    const url = `${window.location.pathname}?${searchParams}`;
    const filterDataUrl = element => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl) ?
      FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.completeRenderPage();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.completeRenderPage();
  }

  static completeRenderPage() {
    const gridContainer = document.getElementById('ProductGridContainer');
    gridContainer.classList.remove('loading');

    if (window.dAgency.proxyLinkSetup) window.dAgency.proxyLinkSetup(gridContainer);

    window.endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'click',
      callback: function (requestURL) {
        window.dAgency.ajaxinateCallBack(requestURL);
      }
    });
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]').forEach(checkbox => {

        const activeLabel = document.querySelector(`label.filters__active-filters__filter[for="${checkbox.id}"]`);

        checkbox.addEventListener('change', function () {
          if (activeLabel) {
            if (checkbox.checked) {
              activeLabel.style.display = '';
              activeLabel.classList.add('active');
            } else {
              activeLabel.style.display = 'none';
              activeLabel.classList.remove('active');
            }
          }
        });
      });
    });

    if (document.querySelectorAll('label.filters__active-filters__filter.active').length == 0) {
      document.querySelector('.active-facets__button-wrapper').style.display = 'none';
    } else {
      document.querySelector('.active-facets__button-wrapper').style.display = '';
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    const range = this.querySelector('.filters-category__slider');
    const minInput = this.querySelector('#Filter-price-min');
    const maxInput = this.querySelector('#Filter-price-max');
    const rangeMin = typeof (this.dataset.min) !== 'undefined' ? parseInt(this.dataset.min) : 0;
    const rangeMax = typeof (this.dataset.max) !== 'undefined' ? parseInt(this.dataset.max) : 100000;
    const valueMin = minInput.value ? parseInt(parseFloat(minInput.value) * 100) : rangeMin;
    const valueMax = maxInput.value ? parseInt(parseFloat(maxInput.value) * 100) : rangeMax;

    if (range && minInput && maxInput) {
      const minLabel = this.querySelector(`label[for="${minInput.id}"]`);
      const maxLabel = this.querySelector(`label[for="${maxInput.id}"]`);

      $(range).slider({
        range: true,
        min: rangeMin,
        max: rangeMax,
        values: [valueMin, valueMax],
        slide: (e, ui) => {
          var minValue = 0;
          if (ui.values[0] > 0) {
            minValue = Math.floor(ui.values[0] / 100);
          }

          minInput.value = minValue;
          if (minLabel) {
            minLabel.innerText = theme.Currency.formatMoney(minValue * 100, theme.strings.moneyFormat).split(',')[0];
          }

          var maxValue = rangeMax / 100;
          if (ui.values[1] < rangeMax) {
            maxValue = Math.ceil(ui.values[1] / 100);
          }
          maxInput.value = maxValue;
          if (maxLabel) {
            maxLabel.innerText = theme.Currency.formatMoney(maxValue * 100, theme.strings.moneyFormat).split(',')[0];
          }
        },
        change: (e) => {
          const formData = new FormData(e.target.closest('form'));
          const searchParams = new URLSearchParams(formData).toString();
          FacetFiltersForm.renderPage(searchParams, e);
        }
      });
    }

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const btnRemoveActive = this.querySelector('a.active-facets__button-remove');

    if (btnRemoveActive) {
      btnRemoveActive.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);

        document.querySelectorAll('label.filters__active-filters__filter').forEach(activeFilter => {
          activeFilter.style.display = 'none';
          activeFilter.classList.remove('active');
        });

        this.style.display = 'none';
      });
    }

    const btnRemoveMobile = this.querySelector('a.mobile-only');

    if (btnRemoveMobile) {
      btnRemoveMobile.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);

        document.querySelectorAll('label.filters__active-filters__filter').forEach(activeFilter => {
          activeFilter.style.display = 'none';
          activeFilter.classList.remove('active');
        });

        document.querySelector('.filters__header-mobile__close').click();

        if (btnRemoveActive) btnRemoveActive.style.display = 'none';
      });
    }
  }
}
customElements.define('facet-remove', FacetRemove);

class SearchBrand extends HTMLElement {
  constructor() {
    super();
    var found = 0;
    $('#searchInput').keyup(function () {

      var searchText = $(this).val().toLowerCase();

      $('.filter__brand > li').each(function () {
        var currentLiText = $(this).text().toLowerCase(),
          showCurrentLi = currentLiText.indexOf(searchText) !== -1;
        $(this).toggle(showCurrentLi);

        if (showCurrentLi) {
          found++;
        }
      });

      $('#noresults').toggle(found <= 0);

      found = 0;
    });
  }
}
customElements.define('search-brand', SearchBrand);
